import * as ambassadorWixPaymentsRefundsV1Refund from './payments-refunds-v1-refund-refunds.http.js';
import * as ambassadorWixPaymentsRefundsV1RefundTypes from './payments-refunds-v1-refund-refunds.types.js';
import * as ambassadorWixPaymentsRefundsV1RefundUniversalTypes from './payments-refunds-v1-refund-refunds.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createRefund(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsRefundsV1RefundUniversalTypes.CreateRefundRequest,
  ambassadorWixPaymentsRefundsV1RefundTypes.CreateRefundRequest,
  ambassadorWixPaymentsRefundsV1RefundUniversalTypes.CreateRefundResponse,
  ambassadorWixPaymentsRefundsV1RefundTypes.CreateRefundResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsRefundsV1Refund.createRefund(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/refunds',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRefund(): __PublicMethodMetaInfo<
  'GET',
  { refundId: string },
  ambassadorWixPaymentsRefundsV1RefundUniversalTypes.GetRefundRequest,
  ambassadorWixPaymentsRefundsV1RefundTypes.GetRefundRequest,
  ambassadorWixPaymentsRefundsV1RefundUniversalTypes.GetRefundResponse,
  ambassadorWixPaymentsRefundsV1RefundTypes.GetRefundResponse
> {
  const payload = { refundId: ':refundId' } as any;

  const getRequestOptions =
    ambassadorWixPaymentsRefundsV1Refund.getRefund(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/refunds/{refundId}',
    pathParams: { refundId: 'refundId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryRefunds(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsRefundsV1RefundUniversalTypes.QueryRefundsRequest,
  ambassadorWixPaymentsRefundsV1RefundTypes.QueryRefundsRequest,
  ambassadorWixPaymentsRefundsV1RefundUniversalTypes.QueryRefundsResponse,
  ambassadorWixPaymentsRefundsV1RefundTypes.QueryRefundsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsRefundsV1Refund.queryRefunds(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/refunds/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Refund as RefundOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Initiator as InitiatorOriginal,
  InitiatorWithLiterals as InitiatorWithLiteralsOriginal,
  StatusInfo as StatusInfoOriginal,
  CreateRefundRequest as CreateRefundRequestOriginal,
  CreateRefundResponse as CreateRefundResponseOriginal,
  GetRefundRequest as GetRefundRequestOriginal,
  GetRefundResponse as GetRefundResponseOriginal,
  QueryRefundsRequest as QueryRefundsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryRefundsResponse as QueryRefundsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  GetRefundabilityRequest as GetRefundabilityRequestOriginal,
  GetRefundabilityResponse as GetRefundabilityResponseOriginal,
  Refundability as RefundabilityOriginal,
  RefundabilityDetailsOneOf as RefundabilityDetailsOneOfOriginal,
  RefundDetails as RefundDetailsOriginal,
  RejectionDetails as RejectionDetailsOriginal,
  RejectionReason as RejectionReasonOriginal,
  RejectionReasonWithLiterals as RejectionReasonWithLiteralsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  SyncRefundRequest as SyncRefundRequestOriginal,
  SyncRefundResponse as SyncRefundResponseOriginal,
  CreateRefundApplicationErrors as CreateRefundApplicationErrorsOriginal,
} from './payments-refunds-v1-refund-refunds.types.js';
